import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, Phone } from "lucide-react";
import { PHONE, PHONE_HREF, LOGO } from "../lib/content";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#1a1410] grain flex flex-col items-center justify-center px-5 py-20">
      <img src={LOGO} alt="B. Thornton Capital & Asset Group" className="h-16 w-auto mb-10" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-lg bg-zinc-950/70 border border-zinc-800 p-10 text-center"
      >
        <XCircle className="h-16 w-16 text-zinc-500 mx-auto" />
        <h1 className="mt-6 font-serif text-4xl text-white">Payment Cancelled</h1>
        <p className="mt-4 text-zinc-300 font-light leading-relaxed">
          No charge was made. Whenever you're ready, you can complete your
          purchase — or reach out and we'll be glad to help you get started.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="cancel-home-link"
            className="inline-flex items-center gap-2 bg-gold-foil text-black text-[12px] font-bold tracking-[0.14em] uppercase px-6 py-3 hover:brightness-110 transition-all"
          >
            <ArrowLeft className="h-4 w-4" /> Return to Site
          </Link>
          <a
            href={PHONE_HREF}
            className="inline-flex items-center gap-2 text-[12px] font-bold tracking-[0.14em] uppercase text-zinc-300 hover:text-amber-400 transition-colors"
          >
            <Phone className="h-4 w-4 text-amber-500" /> {PHONE}
          </a>
        </div>
      </motion.div>
    </div>
  );
}
